import SignpostStep from './SignpostStep';
import { MPFStepFooterObject } from '../../../util/types';

type Props = {
  stepsObject: MPFStepFooterObject[];
}

/**
 * A Signposts component
 * @param props
 */
let Signposts = (props: Props) => {
  // TODO: put in the SignpostStep[] type for accum (TS not liking it...)
  let signpostSteps = props.stepsObject.reduce((accum: any[], step, index) => {

    // Add the step if it has a label (skip the first 'type' step)
    if  (step.label) {
      let el = (<SignpostStep label={step.label} mobileLabel={step.mobileLabel} status={step.status} key={index} />);
      accum.push(el);
    }
    return accum;
  },[]);

  return (
    <div className='Signposts'>
      <div className="Signposts__container">
        {signpostSteps}
      </div>
    </div>
  );
};

export default Signposts;
